import _htmx from "htmx.org";

window.htmx = _htmx;
